import {
    isHardApplicationPhase,
    isPreApprovalApplication,
    isSoftApplicationPhase,
    type ApplicationPhaseOptions,
    type ApplicationPhaseSetupData,
} from '../core/applicationPhase';

export const ApplicationKind = {
    Loan: 'loan',
    Preapproval: 'preapproval',
    Prequalification: 'prequalification',
} as const;

export type ApplicationKind = (typeof ApplicationKind)[keyof typeof ApplicationKind];

export type ApplicationAttributionSetupData = ApplicationPhaseSetupData;
export type ResolveApplicationAttributionOptions = ApplicationPhaseOptions;

export interface ApplicationAttribution {
    applicationKind: ApplicationKind;
    isHardAppFlow: boolean;
}

/**
 * Classifies the current application for Datadog `financingAttribution`.
 *
 * `applicationKind` is what is being submitted now (loan / preapproval / prequalification).
 * `isHardAppFlow` is whether the user is on a hard credit-application path. They diverge for
 * pre-approval conversions: kind is `preapproval`, but the flow is still a hard app.
 */
export const resolveApplicationAttribution = (
    setupData?: ApplicationAttributionSetupData | null,
    options?: ResolveApplicationAttributionOptions,
): ApplicationAttribution => {
    if (isPreApprovalApplication(setupData)) {
        return { applicationKind: ApplicationKind.Preapproval, isHardAppFlow: true };
    }
    if (isSoftApplicationPhase(setupData, options)) {
        return { applicationKind: ApplicationKind.Prequalification, isHardAppFlow: false };
    }
    return {
        applicationKind: ApplicationKind.Loan,
        isHardAppFlow: isHardApplicationPhase(setupData, options),
    };
};
